// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankResponseAPIModel
 */
export interface BankResponseAPIModel {
    /**
     * 
     * @type {string}
     * @memberof BankResponseAPIModel
     */
    bankId: string;
    /**
     * 
     * @type {string}
     * @memberof BankResponseAPIModel
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof BankResponseAPIModel
     */
    icon: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BankResponseAPIModel
     */
    aliases: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BankResponseAPIModel
     */
    steps: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BankResponseAPIModel
     */
    detailsLink: string;
}

export function BankResponseAPIModelFromJSON(json: any): BankResponseAPIModel {
    return BankResponseAPIModelFromJSONTyped(json, false);
}

export function BankResponseAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankResponseAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bankId': json['bankId'],
        'label': json['label'],
        'icon': json['icon'],
        'aliases': json['aliases'],
        'steps': json['steps'],
        'detailsLink': json['detailsLink'],
    };
}

export function BankResponseAPIModelToJSON(value?: BankResponseAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bankId': value.bankId,
        'label': value.label,
        'icon': value.icon,
        'aliases': value.aliases,
        'steps': value.steps,
        'detailsLink': value.detailsLink,
    };
}


